import { SuccessFeeTier } from '../models';

export function validateTierStructure(tiers?: SuccessFeeTier[]) {
	let isValid = false;

	if (!tiers || tiers.length < 2) return false;

	tiers.forEach((tier, index) => {
		if (index == 0) isValid = validateTier(tier as SuccessFeeTier, 'First');
		else if (index == tiers.length - 1) isValid = validateTier(tier as SuccessFeeTier, 'Last', tiers[index - 1]);
		else isValid = validateTier(tier as SuccessFeeTier, 'Middle', tiers[index - 1]);

		if (!isValid) return;
	});

	return isValid;
}

function validateTier(tier: SuccessFeeTier, position: TierPosition, prevTier?: SuccessFeeTier) {
	let isValid = false;
	if (position == 'First') {
		isValid = !(tier.lowerFundingAmount > 0) && tier.lowerFundingAmount < tier.upperFundingAmount!;
	} else if (position == 'Middle') {
		isValid = tier.lowerFundingAmount > 0 && tier.upperFundingAmount !== null && tier.upperFundingAmount > 0;
		isValid = isValid && tier.lowerFundingAmount == prevTier?.upperFundingAmount;
	} else {
		isValid = tier.upperFundingAmount == null && tier.lowerFundingAmount == prevTier?.upperFundingAmount;
	}
	return isValid;
}

type TierPosition = 'First' | 'Middle' | 'Last';
